export const urldecode = (str: string): string => {
  str = str.toString();
  return decodeURIComponent((str)
    .replace(/%(?![\da-f]{2})/gi, function() {
      // PHP tolerates poorly formed escape sequences
      return '%25';
    })
    .replace(/\+/g, '%20'));
};
